import UniversalAIGames from '../../../components/Games/UniversalAIGames';

const DragDropGames = ({ user }) => {
    return <UniversalAIGames user={user} category="simple" />;
};

export default DragDropGames;
